import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';

export function TwoFactorPage() {
  const [code, setCode] = useState('');
  const [isBackup, setIsBackup] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const { refresh } = useAuth();
  const nav = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      await api.post('/auth/2fa/verify', { code, isBackupCode: isBackup });
      await refresh();
      nav('/');
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : 'Fehler');
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rla-50 to-slate-100 p-4">
      <div className="card w-full max-w-md">
        <h1 className="text-xl font-bold text-rla-700 mb-1">Zwei-Faktor-Code</h1>
        <p className="text-sm text-slate-600 mb-6">Code aus deiner Authenticator-App eingeben.</p>
        <form onSubmit={submit} className="space-y-4">
          <input
            type="text" inputMode="numeric" autoComplete="one-time-code"
            className="input text-center text-2xl tracking-widest font-mono"
            required value={code} onChange={(e) => setCode(e.target.value.replace(/\s/g, ''))}
            placeholder={isBackup ? 'Backup-Code' : '000000'} maxLength={isBackup ? 11 : 6} autoFocus
          />
          <label className="flex items-center gap-2 text-sm text-slate-600">
            <input type="checkbox" checked={isBackup} onChange={(e) => setIsBackup(e.target.checked)} className="rounded border-slate-300" />
            Backup-Code verwenden
          </label>
          {err && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-md p-3">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? 'Prüfe …' : 'Bestätigen'}
          </button>
        </form>
      </div>
    </div>
  );
}
